import _slicedToArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BigNumber } from '@ethersproject/bignumber';
import { encodeRouteToPath } from '@uniswap/v3-sdk';
import retry from 'async-retry';
import _ from 'lodash';
import stats from 'stats-lite';
import { IQuoterV2__factory } from '../../types/v3/factories/IQuoterV2__factory';
import { ChainId, metric, MetricLoggerUnit } from '../../util';
import { QUOTER_V2_ADDRESSES } from '../../util/addresses';
import { log } from '../../util/log';
import { routeToString } from '../../util/routes';
export var BlockConflictError = /*#__PURE__*/function (_Error) {
  _inherits(BlockConflictError, _Error);

  var _super = _createSuper(BlockConflictError);

  function BlockConflictError() {
    var _this;

    _classCallCheck(this, BlockConflictError);

    _this = _super.apply(this, arguments);
    _this.name = 'BlockConflictError';
    return _this;
  }

  return _createClass(BlockConflictError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var SuccessRateError = /*#__PURE__*/function (_Error2) {
  _inherits(SuccessRateError, _Error2);

  var _super2 = _createSuper(SuccessRateError);

  function SuccessRateError() {
    var _this2;

    _classCallCheck(this, SuccessRateError);

    _this2 = _super2.apply(this, arguments);
    _this2.name = 'SuccessRateError';
    return _this2;
  }

  return _createClass(SuccessRateError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var ProviderBlockHeaderError = /*#__PURE__*/function (_Error3) {
  _inherits(ProviderBlockHeaderError, _Error3);

  var _super3 = _createSuper(ProviderBlockHeaderError);

  function ProviderBlockHeaderError() {
    var _this3;

    _classCallCheck(this, ProviderBlockHeaderError);

    _this3 = _super3.apply(this, arguments);
    _this3.name = 'ProviderBlockHeaderError';
    return _this3;
  }

  return _createClass(ProviderBlockHeaderError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var ProviderTimeoutError = /*#__PURE__*/function (_Error4) {
  _inherits(ProviderTimeoutError, _Error4);

  var _super4 = _createSuper(ProviderTimeoutError);

  function ProviderTimeoutError() {
    var _this4;

    _classCallCheck(this, ProviderTimeoutError);

    _this4 = _super4.apply(this, arguments);
    _this4.name = 'ProviderTimeoutError';
    return _this4;
  }

  return _createClass(ProviderTimeoutError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * This error typically means that the gas used by the multicall has
 * exceeded the total call gas limit set by the node provider.
 *
 * This can be resolved by modifying BatchParams to request fewer
 * quotes per call, or to set a lower gas limit per quote.
 *
 * @export
 * @class ProviderGasError
 */

export var ProviderGasError = /*#__PURE__*/function (_Error5) {
  _inherits(ProviderGasError, _Error5);

  var _super5 = _createSuper(ProviderGasError);

  function ProviderGasError() {
    var _this5;

    _classCallCheck(this, ProviderGasError);

    _this5 = _super5.apply(this, arguments);
    _this5.name = 'ProviderGasError';
    return _this5;
  }

  return _createClass(ProviderGasError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var DEFAULT_BATCH_RETRIES = 2;
/**
 * Computes quotes for V3. For V3, quotes are computed on-chain using
 * the 'QuoterV2' smart contract. This is because computing quotes off-chain would
 * require fetching all the tick data for each pool, which is a lot of data.
 *
 * To minimize the number of requests for quotes we use a Multicall contract. Generally
 * the number of quotes to fetch exceeds the maximum we can fit in a single multicall
 * while staying under gas limits, so we also batch these quotes across multiple multicalls.
 *
 * The biggest challenge with the quote provider is dealing with various gas limits.
 * Each provider sets a limit on the amount of gas a call can consume (on Infura this
 * is approximately 10x the block max size), so we must ensure each multicall does not
 * exceed this limit. Additionally, each quote on V3 can consume a large number of gas if
 * the pool lacks liquidity and the swap would cause all the ticks to be traversed.
 *
 * To ensure we don't exceed the node's call limit, we limit the gas used by each quote to
 * a specific value, and we limit the number of quotes in each multicall request. Users of this
 * class should set BatchParams such that multicallChunk * gasLimitPerCall is less than their node
 * providers total gas limit per call.
 *
 * @export
 * @class V3QuoteProvider
 */

export var V3QuoteProvider = /*#__PURE__*/function () {
  /**
   * Creates an instance of V3QuoteProvider.
   *
   * @param chainId The chain to get quotes for.
   * @param provider The web 3 provider.
   * @param multicall2Provider The multicall provider to use to get the quotes on-chain.
   * Only supports the Uniswap Multicall contract as it needs the gas limitting functionality.
   * @param retryOptions The retry options for each call to the multicall.
   * @param batchParams The parameters for each batched call to the multicall.
   * @param gasErrorFailureOverride The gas and chunk parameters to use when retrying a batch that failed due to out of gas.
   * @param successRateFailureOverrides The parameters for retries when we fail to get quotes.
   * @param blockNumberConfig Parameters for adjusting which block we get quotes from, and how to handle block header not found errors.
   * @param [quoterAddressOverride] Overrides the address of the quoter contract to use.
   */
  function V3QuoteProvider(chainId, provider, // Only supports Uniswap Multicall as it needs the gas limitting functionality.
  multicall2Provider) {
    var retryOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
      retries: DEFAULT_BATCH_RETRIES,
      minTimeout: 25,
      maxTimeout: 250
    };
    var batchParams = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
      multicallChunk: 150,
      gasLimitPerCall: 1000000,
      quoteMinSuccessRate: 0.2
    };
    var gasErrorFailureOverride = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
      gasLimitOverride: 1500000,
      multicallChunk: 100
    };
    var successRateFailureOverrides = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {
      gasLimitOverride: 1300000,
      multicallChunk: 110
    };
    var blockNumberConfig = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {
      baseBlockOffset: 0,
      rollback: {
        enabled: false
      }
    };
    var quoterAddressOverride = arguments.length > 8 ? arguments[8] : undefined;

    _classCallCheck(this, V3QuoteProvider);

    this.chainId = chainId;
    this.provider = provider;
    this.multicall2Provider = multicall2Provider;
    this.retryOptions = retryOptions;
    this.batchParams = batchParams;
    this.gasErrorFailureOverride = gasErrorFailureOverride;
    this.successRateFailureOverrides = successRateFailureOverrides;
    this.blockNumberConfig = blockNumberConfig;
    this.quoterAddressOverride = quoterAddressOverride;
    var quoterAddress = quoterAddressOverride ? quoterAddressOverride : QUOTER_V2_ADDRESSES[this.chainId];

    if (!quoterAddress) {
      throw new Error("No address for Uniswap QuoterV2 Contract on chain id: ".concat(chainId));
    }

    this.quoterAddress = quoterAddress;
  }

  _createClass(V3QuoteProvider, [{
    key: "getQuotesManyExactIn",
    value: function () {
      var _getQuotesManyExactIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(amountIns, routes, providerConfig) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.getQuotesManyData(amountIns, routes, 'quoteExactInput', providerConfig));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getQuotesManyExactIn(_x, _x2, _x3) {
        return _getQuotesManyExactIn.apply(this, arguments);
      }

      return getQuotesManyExactIn;
    }()
  }, {
    key: "getQuotesManyExactOut",
    value: function () {
      var _getQuotesManyExactOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(amountOuts, routes, providerConfig) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.getQuotesManyData(amountOuts, routes, 'quoteExactOutput', providerConfig));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getQuotesManyExactOut(_x4, _x5, _x6) {
        return _getQuotesManyExactOut.apply(this, arguments);
      }

      return getQuotesManyExactOut;
    }()
  }, {
    key: "getQuotesManyData",
    value: function () {
      var _getQuotesManyData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(amounts, routes, functionName, _providerConfig) {
        var _this6 = this;

        var _a, multicallChunk, gasLimitOverride, _this$blockNumberConf, baseBlockOffset, rollback, originalBlockNumber, providerConfig, inputs, normalizedChunk, inputsChunked, quoteStates, haveRetriedForSuccessRate, haveRetriedForBlockHeader, blockHeaderRetryAttemptNumber, haveIncrementedBlockHeaderFailureCounter, blockHeaderRolledBack, haveRetriedForBlockConflictError, haveRetriedForOutOfGas, haveRetriedForTimeout, haveRetriedForUnknownReason, finalAttemptNumber, expectedCallsMade, totalCallsMade, _yield$retry, quoteResults, blockNumber, approxGasUsedPerSuccessCall, routesQuotes, _$flatMap$partition$v, _$flatMap$partition$v2, successfulQuotes, failedQuotes;

        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                multicallChunk = this.batchParams.multicallChunk;
                gasLimitOverride = this.batchParams.gasLimitPerCall;
                _this$blockNumberConf = this.blockNumberConfig, baseBlockOffset = _this$blockNumberConf.baseBlockOffset, rollback = _this$blockNumberConf.rollback; // Apply the base block offset if provided

                _context5.next = 5;
                return this.provider.getBlockNumber();

              case 5:
                originalBlockNumber = _context5.sent;
                providerConfig = _objectSpread(_objectSpread({}, _providerConfig), {}, {
                  blockNumber: (_a = _providerConfig === null || _providerConfig === void 0 ? void 0 : _providerConfig.blockNumber) !== null && _a !== void 0 ? _a : originalBlockNumber + baseBlockOffset
                });
                inputs = _(routes).flatMap(function (route) {
                  var encodedRoute = encodeRouteToPath(route, functionName == 'quoteExactOutput' // For exactOut must be true to ensure the routes are reversed.
                  );
                  var routeInputs = amounts.map(function (amount) {
                    return [encodedRoute, "0x".concat(amount.quotient.toString(16))];
                  });
                  return routeInputs;
                }).value();
                normalizedChunk = Math.ceil(inputs.length / Math.ceil(inputs.length / multicallChunk));
                inputsChunked = _.chunk(inputs, normalizedChunk);
                quoteStates = _.map(inputsChunked, function (inputChunk) {
                  return {
                    status: 'pending',
                    inputs: inputChunk
                  };
                });
                _context5.t0 = log;
                _context5.t1 = "About to get ".concat(inputs.length, " quotes in chunks of ").concat(normalizedChunk, " [").concat(_.map(inputsChunked, function (i) {
                  return i.length;
                }).join(','), "] ").concat(gasLimitOverride ? "with a gas limit override of ".concat(gasLimitOverride) : '', " and block number: ");
                _context5.next = 15;
                return providerConfig.blockNumber;

              case 15:
                _context5.t2 = _context5.sent;
                _context5.t3 = _context5.t1.concat.call(_context5.t1, _context5.t2, " [Original before offset: ").concat(originalBlockNumber, "].");

                _context5.t0.info.call(_context5.t0, _context5.t3);

                haveRetriedForSuccessRate = false;
                haveRetriedForBlockHeader = false;
                blockHeaderRetryAttemptNumber = 0;
                haveIncrementedBlockHeaderFailureCounter = false;
                blockHeaderRolledBack = false;
                haveRetriedForBlockConflictError = false;
                haveRetriedForOutOfGas = false;
                haveRetriedForTimeout = false;
                haveRetriedForUnknownReason = false;
                finalAttemptNumber = 1;
                expectedCallsMade = quoteStates.length;
                totalCallsMade = 0;
                _context5.next = 32;
                return retry( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_bail, attemptNumber) {
                    var _this6$partitionQuote, _this6$partitionQuote2, success, failed, pending, _this6$partitionQuote3, _this6$partitionQuote4, successfulQuoteStates, failedQuoteStates, pendingQuoteStates, retryAll, blockNumberError, reasonForFailureStr, _iterator, _step, failedQuoteState, error, rollbackBlockOffset, attemptsBeforeRollback, _normalizedChunk, _inputsChunked, callResults;

                    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            haveIncrementedBlockHeaderFailureCounter = false;
                            finalAttemptNumber = attemptNumber;
                            _this6$partitionQuote = _this6.partitionQuotes(quoteStates), _this6$partitionQuote2 = _slicedToArray(_this6$partitionQuote, 3), success = _this6$partitionQuote2[0], failed = _this6$partitionQuote2[1], pending = _this6$partitionQuote2[2];
                            log.info("Starting attempt: ".concat(attemptNumber, ".\n          Currently ").concat(success.length, " success, ").concat(failed.length, " failed, ").concat(pending.length, " pending.\n          Gas limit override: ").concat(gasLimitOverride, " Block number override: ").concat(providerConfig.blockNumber, "."));
                            _context4.next = 6;
                            return Promise.all(_.map(quoteStates, /*#__PURE__*/function () {
                              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(quoteState, idx) {
                                var inputs, results, successRateError;
                                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                                  while (1) {
                                    switch (_context3.prev = _context3.next) {
                                      case 0:
                                        if (!(quoteState.status == 'success')) {
                                          _context3.next = 2;
                                          break;
                                        }

                                        return _context3.abrupt("return", quoteState);

                                      case 2:
                                        // QuoteChunk is pending or failed, so we try again
                                        inputs = quoteState.inputs;
                                        _context3.prev = 3;
                                        totalCallsMade = totalCallsMade + 1;
                                        _context3.next = 7;
                                        return _this6.multicall2Provider.callSameFunctionOnContractWithMultipleParams({
                                          address: _this6.quoterAddress,
                                          contractInterface: IQuoterV2__factory.createInterface(),
                                          functionName: functionName,
                                          functionParams: inputs,
                                          providerConfig: providerConfig,
                                          additionalConfig: {
                                            gasLimitPerCallOverride: gasLimitOverride
                                          }
                                        });

                                      case 7:
                                        results = _context3.sent;
                                        successRateError = _this6.validateSuccessRate(results.results, haveRetriedForSuccessRate);

                                        if (!successRateError) {
                                          _context3.next = 11;
                                          break;
                                        }

                                        return _context3.abrupt("return", {
                                          status: 'failed',
                                          inputs: inputs,
                                          reason: successRateError,
                                          results: results
                                        });

                                      case 11:
                                        return _context3.abrupt("return", {
                                          status: 'success',
                                          inputs: inputs,
                                          results: results
                                        });

                                      case 14:
                                        _context3.prev = 14;
                                        _context3.t0 = _context3["catch"](3);

                                        if (!_context3.t0.message.includes('header not found')) {
                                          _context3.next = 18;
                                          break;
                                        }

                                        return _context3.abrupt("return", {
                                          status: 'failed',
                                          inputs: inputs,
                                          reason: new ProviderBlockHeaderError(_context3.t0.message.slice(0, 500))
                                        });

                                      case 18:
                                        if (!_context3.t0.message.includes('timeout')) {
                                          _context3.next = 20;
                                          break;
                                        }

                                        return _context3.abrupt("return", {
                                          status: 'failed',
                                          inputs: inputs,
                                          reason: new ProviderTimeoutError("Req ".concat(idx, "/").concat(quoteStates.length, ". Request had ").concat(inputs.length, " inputs. ").concat(_context3.t0.message.slice(0, 500)))
                                        });

                                      case 20:
                                        if (!_context3.t0.message.includes('out of gas')) {
                                          _context3.next = 22;
                                          break;
                                        }

                                        return _context3.abrupt("return", {
                                          status: 'failed',
                                          inputs: inputs,
                                          reason: new ProviderGasError(_context3.t0.message.slice(0, 500))
                                        });

                                      case 22:
                                        return _context3.abrupt("return", {
                                          status: 'failed',
                                          inputs: inputs,
                                          reason: new Error("Unknown error from provider: ".concat(_context3.t0.message.slice(0, 500)))
                                        });

                                      case 23:
                                      case "end":
                                        return _context3.stop();
                                    }
                                  }
                                }, _callee3, null, [[3, 14]]);
                              }));

                              return function (_x13, _x14) {
                                return _ref2.apply(this, arguments);
                              };
                            }()));

                          case 6:
                            quoteStates = _context4.sent;
                            _this6$partitionQuote3 = _this6.partitionQuotes(quoteStates), _this6$partitionQuote4 = _slicedToArray(_this6$partitionQuote3, 3), successfulQuoteStates = _this6$partitionQuote4[0], failedQuoteStates = _this6$partitionQuote4[1], pendingQuoteStates = _this6$partitionQuote4[2];

                            if (!(pendingQuoteStates.length > 0)) {
                              _context4.next = 10;
                              break;
                            }

                            throw new Error('Pending quote after waiting for all promises.');

                          case 10:
                            retryAll = false;
                            blockNumberError = _this6.validateBlockNumbers(successfulQuoteStates, inputsChunked.length, gasLimitOverride); // If there is a block number conflict we retry all the quotes.

                            if (blockNumberError) {
                              retryAll = true;
                            }

                            reasonForFailureStr = _.map(failedQuoteStates, function (failedQuoteState) {
                              return failedQuoteState.reason.name;
                            }).join(', ');

                            if (!(failedQuoteStates.length > 0)) {
                              _context4.next = 64;
                              break;
                            }

                            log.info("On attempt ".concat(attemptNumber, ": ").concat(failedQuoteStates.length, "/").concat(quoteStates.length, " quotes failed. Reasons: ").concat(reasonForFailureStr));
                            _iterator = _createForOfIteratorHelper(failedQuoteStates);
                            _context4.prev = 17;

                            _iterator.s();

                          case 19:
                            if ((_step = _iterator.n()).done) {
                              _context4.next = 56;
                              break;
                            }

                            failedQuoteState = _step.value;
                            error = failedQuoteState.reason;
                            log.info({
                              error: error
                            }, "[QuoteFetchError] Attempt ".concat(attemptNumber, ". ").concat(error.message));

                            if (!(error instanceof BlockConflictError)) {
                              _context4.next = 28;
                              break;
                            }

                            if (!haveRetriedForBlockConflictError) {
                              metric.putMetric('QuoteBlockConflictErrorRetry', 1, MetricLoggerUnit.Count);
                              haveRetriedForBlockConflictError = true;
                            }

                            retryAll = true;
                            _context4.next = 54;
                            break;

                          case 28:
                            if (!(error instanceof ProviderBlockHeaderError)) {
                              _context4.next = 53;
                              break;
                            }

                            if (!haveRetriedForBlockHeader) {
                              metric.putMetric('QuoteBlockHeaderNotFoundRetry', 1, MetricLoggerUnit.Count);
                              haveRetriedForBlockHeader = true;
                            } // Ensure that if multiple calls fail due to block header in the current pending batch,
                            // we only count once.


                            if (!haveIncrementedBlockHeaderFailureCounter) {
                              blockHeaderRetryAttemptNumber = blockHeaderRetryAttemptNumber + 1;
                              haveIncrementedBlockHeaderFailureCounter = true;
                            }

                            if (!rollback.enabled) {
                              _context4.next = 51;
                              break;
                            }

                            rollbackBlockOffset = rollback.rollbackBlockOffset, attemptsBeforeRollback = rollback.attemptsBeforeRollback;

                            if (!(blockHeaderRetryAttemptNumber >= attemptsBeforeRollback && !blockHeaderRolledBack)) {
                              _context4.next = 51;
                              break;
                            }

                            log.info("Attempt ".concat(attemptNumber, ". Have failed due to block header ").concat(blockHeaderRetryAttemptNumber - 1, " times. Rolling back block number by ").concat(rollbackBlockOffset, " for next retry"));

                            if (!providerConfig.blockNumber) {
                              _context4.next = 43;
                              break;
                            }

                            _context4.next = 38;
                            return providerConfig.blockNumber;

                          case 38:
                            _context4.t1 = _context4.sent;
                            _context4.t2 = rollbackBlockOffset;
                            _context4.t0 = _context4.t1 + _context4.t2;
                            _context4.next = 48;
                            break;

                          case 43:
                            _context4.next = 45;
                            return _this6.provider.getBlockNumber();

                          case 45:
                            _context4.t3 = _context4.sent;
                            _context4.t4 = rollbackBlockOffset;
                            _context4.t0 = _context4.t3 + _context4.t4;

                          case 48:
                            providerConfig.blockNumber = _context4.t0;
                            retryAll = true;
                            blockHeaderRolledBack = true;

                          case 51:
                            _context4.next = 54;
                            break;

                          case 53:
                            if (error instanceof ProviderTimeoutError) {
                              if (!haveRetriedForTimeout) {
                                metric.putMetric('QuoteTimeoutRetry', 1, MetricLoggerUnit.Count);
                                haveRetriedForTimeout = true;
                              }
                            } else if (error instanceof ProviderGasError) {
                              if (!haveRetriedForOutOfGas) {
                                metric.putMetric('QuoteOutOfGasExceptionRetry', 1, MetricLoggerUnit.Count);
                                haveRetriedForOutOfGas = true;
                              }

                              gasLimitOverride = _this6.gasErrorFailureOverride.gasLimitOverride;
                              multicallChunk = _this6.gasErrorFailureOverride.multicallChunk;
                              retryAll = true;
                            } else if (error instanceof SuccessRateError) {
                              if (!haveRetriedForSuccessRate) {
                                metric.putMetric('QuoteSuccessRateRetry', 1, MetricLoggerUnit.Count);
                                haveRetriedForSuccessRate = true; // Low success rate can indicate too little gas given to each call.

                                gasLimitOverride = _this6.successRateFailureOverrides.gasLimitOverride;
                                multicallChunk = _this6.successRateFailureOverrides.multicallChunk;
                                retryAll = true;
                              }
                            } else {
                              if (!haveRetriedForUnknownReason) {
                                metric.putMetric('QuoteUnknownReasonRetry', 1, MetricLoggerUnit.Count);
                                haveRetriedForUnknownReason = true;
                              }
                            }

                          case 54:
                            _context4.next = 19;
                            break;

                          case 56:
                            _context4.next = 61;
                            break;

                          case 58:
                            _context4.prev = 58;
                            _context4.t5 = _context4["catch"](17);

                            _iterator.e(_context4.t5);

                          case 61:
                            _context4.prev = 61;

                            _iterator.f();

                            return _context4.finish(61);

                          case 64:
                            if (retryAll) {
                              log.info("Attempt ".concat(attemptNumber, ". Resetting all requests to pending for next attempt."));
                              _normalizedChunk = Math.ceil(inputs.length / Math.ceil(inputs.length / multicallChunk));
                              _inputsChunked = _.chunk(inputs, _normalizedChunk);
                              quoteStates = _.map(_inputsChunked, function (inputChunk) {
                                return {
                                  status: 'pending',
                                  inputs: inputChunk
                                };
                              });
                            }

                            if (!(failedQuoteStates.length > 0)) {
                              _context4.next = 70;
                              break;
                            }

                            if (!((_this6.chainId == ChainId.ARBITRUM_ONE || _this6.chainId == ChainId.ARBITRUM_RINKEBY) && _.every(failedQuoteStates, function (failedQuoteState) {
                              return failedQuoteState.reason instanceof ProviderGasError;
                            }) && attemptNumber == _this6.retryOptions.retries)) {
                              _context4.next = 69;
                              break;
                            }

                            log.error("Failed to get quotes on Arbitrum due to provider gas error issue. Overriding error to return 0 quotes.");
                            return _context4.abrupt("return", {
                              results: [],
                              blockNumber: BigNumber.from(0),
                              approxGasUsedPerSuccessCall: 0
                            });

                          case 69:
                            throw new Error("Failed to get ".concat(failedQuoteStates.length, " quotes. Reasons: ").concat(reasonForFailureStr));

                          case 70:
                            callResults = _.map(successfulQuoteStates, function (quoteState) {
                              return quoteState.results;
                            });
                            return _context4.abrupt("return", {
                              results: _.flatMap(callResults, function (result) {
                                return result.results;
                              }),
                              blockNumber: BigNumber.from(callResults[0].blockNumber),
                              approxGasUsedPerSuccessCall: stats.percentile(_.map(callResults, function (result) {
                                return result.approxGasUsedPerSuccessCall;
                              }), 100)
                            });

                          case 72:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4, null, [[17, 58, 61, 64]]);
                  }));

                  return function (_x11, _x12) {
                    return _ref.apply(this, arguments);
                  };
                }(), _objectSpread({
                  retries: DEFAULT_BATCH_RETRIES
                }, this.retryOptions));

              case 32:
                _yield$retry = _context5.sent;
                quoteResults = _yield$retry.results;
                blockNumber = _yield$retry.blockNumber;
                approxGasUsedPerSuccessCall = _yield$retry.approxGasUsedPerSuccessCall;
                routesQuotes = this.processQuoteResults(quoteResults, routes, amounts);
                metric.putMetric('QuoteApproxGasUsedPerSuccessfulCall', approxGasUsedPerSuccessCall, MetricLoggerUnit.Count);
                metric.putMetric('QuoteNumRetryLoops', finalAttemptNumber - 1, MetricLoggerUnit.Count);
                metric.putMetric('QuoteTotalCallsToProvider', totalCallsMade, MetricLoggerUnit.Count);
                metric.putMetric('QuoteExpectedCallsToProvider', expectedCallsMade, MetricLoggerUnit.Count);
                metric.putMetric('QuoteNumRetriedCalls', totalCallsMade - expectedCallsMade, MetricLoggerUnit.Count);
                _$flatMap$partition$v = _(routesQuotes).flatMap(function (routeWithQuotes) {
                  return routeWithQuotes[1];
                }).partition(function (quote) {
                  return quote.quote != null;
                }).value(), _$flatMap$partition$v2 = _slicedToArray(_$flatMap$partition$v, 2), successfulQuotes = _$flatMap$partition$v2[0], failedQuotes = _$flatMap$partition$v2[1];
                log.info("Got ".concat(successfulQuotes.length, " successful quotes, ").concat(failedQuotes.length, " failed quotes. Took ").concat(finalAttemptNumber - 1, " attempt loops. Total calls made to provider: ").concat(totalCallsMade, ". Have retried for timeout: ").concat(haveRetriedForTimeout));
                return _context5.abrupt("return", {
                  routesWithQuotes: routesQuotes,
                  blockNumber: blockNumber
                });

              case 45:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getQuotesManyData(_x7, _x8, _x9, _x10) {
        return _getQuotesManyData.apply(this, arguments);
      }

      return getQuotesManyData;
    }()
  }, {
    key: "partitionQuotes",
    value: function partitionQuotes(quoteStates) {
      var successfulQuoteStates = _.filter(quoteStates, function (quoteState) {
        return quoteState.status == 'success';
      });

      var failedQuoteStates = _.filter(quoteStates, function (quoteState) {
        return quoteState.status == 'failed';
      });

      var pendingQuoteStates = _.filter(quoteStates, function (quoteState) {
        return quoteState.status == 'pending';
      });

      return [successfulQuoteStates, failedQuoteStates, pendingQuoteStates];
    }
  }, {
    key: "processQuoteResults",
    value: function processQuoteResults(quoteResults, routes, amounts) {
      var routesQuotes = [];

      var quotesResultsByRoute = _.chunk(quoteResults, amounts.length);

      var debugFailedQuotes = [];

      var _loop = function _loop(i) {
        var route = routes[i];
        var quoteResults = quotesResultsByRoute[i];

        var quotes = _.map(quoteResults, function (quoteResult, index) {
          var amount = amounts[index];

          if (!quoteResult.success) {
            var percent = 100 / amounts.length * (index + 1);
            var amountStr = amount.toFixed(Math.min(amount.currency.decimals, 2));
            var routeStr = routeToString(route);
            debugFailedQuotes.push({
              route: routeStr,
              percent: percent,
              amount: amountStr
            });
            return {
              amount: amount,
              quote: null,
              sqrtPriceX96AfterList: null,
              gasEstimate: null,
              initializedTicksCrossedList: null
            };
          }

          return {
            amount: amount,
            quote: quoteResult.result[0],
            sqrtPriceX96AfterList: quoteResult.result[1],
            initializedTicksCrossedList: quoteResult.result[2],
            gasEstimate: quoteResult.result[3]
          };
        });

        routesQuotes.push([route, quotes]);
      };

      for (var i = 0; i < quotesResultsByRoute.length; i++) {
        _loop(i);
      } // For routes and amounts that we failed to get a quote for, group them by route
      // and batch them together before logging to minimize number of logs.


      var debugChunk = 80;

      _.forEach(_.chunk(debugFailedQuotes, debugChunk), function (quotes, idx) {
        var failedQuotesByRoute = _.groupBy(quotes, function (q) {
          return q.route;
        });

        var failedFlat = _.mapValues(failedQuotesByRoute, function (f) {
          return _(f).map(function (f) {
            return "".concat(f.percent, "%[").concat(f.amount, "]");
          }).join(',');
        });

        log.info({
          failedQuotes: _.map(failedFlat, function (amounts, routeStr) {
            return "".concat(routeStr, " : ").concat(amounts);
          })
        }, "Failed quotes for V3 routes Part ".concat(idx, "/").concat(Math.ceil(debugFailedQuotes.length / debugChunk)));
      });

      return routesQuotes;
    }
  }, {
    key: "validateBlockNumbers",
    value: function validateBlockNumbers(successfulQuoteStates, totalCalls, gasLimitOverride) {
      if (successfulQuoteStates.length <= 1) {
        return null;
      }

      var results = _.map(successfulQuoteStates, function (quoteState) {
        return quoteState.results;
      });

      var blockNumbers = _.map(results, function (result) {
        return result.blockNumber;
      });

      var uniqBlocks = _(blockNumbers).map(function (blockNumber) {
        return blockNumber.toNumber();
      }).uniq().value();

      if (uniqBlocks.length == 1) {
        return null;
      }
      /* if (
        uniqBlocks.length == 2 &&
        Math.abs(uniqBlocks[0]! - uniqBlocks[1]!) <= 1
      ) {
        return null;
      } */


      return new BlockConflictError("Quotes returned from different blocks. ".concat(uniqBlocks, ". ").concat(totalCalls, " calls were made with gas limit ").concat(gasLimitOverride));
    }
  }, {
    key: "validateSuccessRate",
    value: function validateSuccessRate(allResults, haveRetriedForSuccessRate) {
      var numResults = allResults.length;
      var numSuccessResults = allResults.filter(function (result) {
        return result.success;
      }).length;
      var successRate = 1.0 * numSuccessResults / numResults;
      var quoteMinSuccessRate = this.batchParams.quoteMinSuccessRate;

      if (successRate < quoteMinSuccessRate) {
        if (haveRetriedForSuccessRate) {
          log.info("Quote success rate still below threshold despite retry. Continuing. ".concat(quoteMinSuccessRate, ": ").concat(successRate));
          return;
        }

        return new SuccessRateError("Quote success rate below threshold of ".concat(quoteMinSuccessRate, ": ").concat(successRate));
      }
    }
  }]);

  return V3QuoteProvider;
}();